import { elementZh, vantZh } from "./components/zh-CN.js";
import { elementEn, vantEn } from "./components/en-US.js";
import { elementHk, vantHk } from "./components/zh-HK.js";
import { selectComponentLocale } from "./components/index.js";
import elementLocale from "element-ui/lib/locale";
import { Locale as vantLocale } from "vant";
import { translate } from "./catalog";
import { UI_LOCALE_STORAGE_KEY } from "./common/index.js";

const syncComponentLocales = (locale) => {
  elementLocale.use(
    selectComponentLocale(locale, elementZh, elementEn, elementHk)
  );
  vantLocale.use(locale, selectComponentLocale(locale, vantZh, vantEn, vantHk));
  if (typeof document !== "undefined") document.documentElement.lang = locale;
};

export const installStaticI18n = (Vue, store) => {
  Vue.prototype.$t = (key, params) =>
    translate(store.state.locale.uiLocale, key, params);
  syncComponentLocales(store.state.locale.uiLocale);
  store.subscribe((mutation, state) => {
    if (mutation.type === "locale/setUiLocale") {
      syncComponentLocales(state.locale.uiLocale);
    }
  });
  if (typeof window !== "undefined") {
    window.addEventListener("storage", (event) => {
      if (event.key === UI_LOCALE_STORAGE_KEY && event.newValue) {
        store.commit("locale/setUiLocale", event.newValue);
      }
    });
  }
};
